import React, { useState, useCallback, useEffect } from "react";
import { useModal } from "react-modal-hook";
import { Formik, Form, Field } from "formik";
import { useSelector } from "react-redux";
import Modal from "../../../../components/Modal/Modal";
import InputError from "../../../../components/InputError/InputError";
import NeoOTP from "../../../../components/FormComponents/NeoOTP";
import NeoButton from "../../../../components/NeoButton/NeoButton";
import NeoInput from "../../../../components/NeoInput/NeoInput";
import NeoLoader from "../../../../components/FormComponents/NeoLoader";
import { useHistory } from "react-router-dom";
import { CardRequestSchema } from "../../../../schemas/requests";
import RequestService from "../../../../services/request.service";
import {
  BUTTON_KEYS,
  CARD_REQUEST_KEYS,
} from "../../../../utils/translation-constants";
import { useTranslation } from "react-i18next";
import { getAccountListSelector } from "../../../../store/selectors/app.selector";
import LayoutWithOutAccountCard from "../../../Layout/layout-without-card";
import validationConfig from 'custom/config/validation.config.json'
import { NeoSuccess } from "../../../../components/FormComponents";
const cardRequestConfig = validationConfig['cardRequest']
import config from "custom/config/environment"
import TermsAndCondition from "../../../../components/TermsAndConditions/TermsAndCondition";

export default function CardRequest() {
  const { t } = useTranslation();
  const [otpEnabled, setOtpEnabled] = useState(false);
  const [stage, setStage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [message, setMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [verifyDetails, setVerifyDetails] = useState({})
  const accountList = useSelector(getAccountListSelector) || []
  const [cardDetails, setCardDetails]=useState([])
  const [branchList, setBranchList]=useState([])

  const history = useHistory();

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className="modal-error-body">
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className="modal-btn-style">
            <NeoButton
              tabIndex="1"
              mode="newDesign"
              type="button"
              text={t(BUTTON_KEYS.CLOSE)}
              onClick={() => {
                hideModal();
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message]
  );

  useEffect(()=>{
    getCardDeatils()
    getPickUpBranches()
  },[])

  const getCardDeatils = useCallback(
    async () => {
      try {
        setLoading(true)
        const response = await RequestService.getCardDetails({})
        if (response.status === 200) {
          setCardDetails(response.data)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [],
  )


  const getPickUpBranches = useCallback(
    async () => {
      try {
        setLoading(true)
        const response = await RequestService.getAllBranches({})
        if (response.status === 200) {
          setBranchList(response.data)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [],)

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();
      case 2:
        return renderConfirmation();
      case 3:
        return (
          <NeoOTP
            loading={loading}
            otp={otp}
            setOTP={setOtp}
            onSubmit={confirmCardRequest}
          />
        );
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return renderForm();
    }
  }

  const onSubmitCardRequest = useCallback(
    async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        const accDetails = accountList.filter((ele) => ele.accountNo === values.accountNo)[0]
        const seletedCard= cardDetails.filter((e)=>e.cardProductCode===values.cardProducts)  
        const response = await RequestService.verifyCardRequest({
          srcAccount: accDetails?.accountNo,
          srcAccBranch: accDetails?.brnCode,
          srcAccCcy: accDetails?.currency,
          deliveryBranch: values.deliveryMode === "BRANCH" ? values.deliveryBranch : "",
          deliveryMode: values.deliveryMode,
          cardProducts: values.cardProducts,
          requestType: values.requestType

        });
        if (response.status === 200) {
        setFormValues(values);

          setVerifyDetails(response.data)
          setSubmitting(false);
          setLoading(false);
          setOtpEnabled(response.data["otpEnable"]);
          setLoading(false);
          setStage(2);
        }
      } catch (err) {
        setSubmitting(false);
        setLoading(false);
      }
    },
    [showModal, verifyDetails]
  );

  const confirmCardRequest = useCallback(async () => {
    try {
      setLoading(true);
      const accDetails = accountList.filter((ele) => ele.accountNo === formValues.accountNo)[0]
      const response = await RequestService.confirmCardRequest({
        srcAccount: formValues?.accountNo,
        srcAccBranch: accDetails?.brnCode,
        srcAccCcy: accDetails?.currency,
        deliveryBranch: formValues.deliveryMode === "BRANCH" ? formValues.deliveryBranch : "",
        deliveryMode: formValues.deliveryMode,
        cardProducts: formValues.cardProducts,
        requestType: formValues.requestType,
        otp,
        randomKey: verifyDetails.randomKey
      });
      if (response.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4);
      }
    } catch (err) {
      setOtp("");
      setLoading(false);
    }
  }, [otp, formValues, verifyDetails]);

  function renderLoading() {
    return (
      <div className="mx-4 rounded d-flex justify-content-center align-items-center">
        <NeoLoader width="50px" height="50px" />
      </div>
    );
  }

  function renderForm() {
    return (
      <div>
        <div className="heading-style">{t(CARD_REQUEST_KEYS.TITLE)}</div>
        <Formik
          initialValues={{
            accountNo: '',
            deliveryMode:'BRANCH',
            deliveryBranch:'',
            requestType:'',
            cardProducts:''
          }}
          validationSchema={CardRequestSchema}
          onSubmit={onSubmitCardRequest}
        >
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue, resetForm, setTouched  }) => (
            <Form>
              <div className='form-group col-12 justify-content-center mb-3'>
                <div className='custom-control custom-radio custom-control-inline'>
                  <Field
                    as='input'
                    value='BRANCH'
                    type='radio'
                    id='branch'
                    name='deliveryMode'
                    className='custom-control-input'
                    onClick={resetForm}
                    disabled={isSubmitting}
                  />
                  <label className='custom-control-label' htmlFor='branch'>
                    {t(CARD_REQUEST_KEYS.BRANCH)}
                  </label>
                </div>
                <div className='custom-control custom-radio custom-control-inline'>
                  <Field
                    as='input'
                    type='radio'
                    id='address'
                    name='deliveryMode'
                    value='ADDRESS'
                    className='custom-control-input'
                    onClick={resetForm}
                    disabled={isSubmitting}
                  />
                  <label className='custom-control-label' htmlFor='address'>
                    {t(CARD_REQUEST_KEYS.ADDRESS)}
                  </label>
                </div>
              </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex="1"
                    showAsterisk={cardRequestConfig["isAccountNoRequired"]}
                    text={t(CARD_REQUEST_KEYS.ACCOUNT_NO)}
                    name='accountNo'
                    mode='select'
                    list={accountList}
                    keyValue='accountNo'
                    value={values.accountNo}
                    onChange={(e)=>{
                      handleChange(e)
                      setFieldValue('deliveryBranch', branchList.find((ele) => ele.branchCode === (accountList.find((ele) => ele.accountNo === e.target.value).brnCode)).address)
                      setTouched({ ...touched, deliveryBranch: false })
                      setFieldValue('accountNo', e.target.value)
                  }}
                  />
                  <InputError text={errors.accountNo} touched={touched.accountNo} />
                </div>
                <div className='form-group col-12'>
                <NeoInput
                    tabIndex="2"
                    showAsterisk={cardRequestConfig["isCardProductRequired"]}
                    text={t(CARD_REQUEST_KEYS.CARD_PRODUCTS)}
                    name='cardProducts'
                    mode='select'
                    list={cardDetails}
                    keyValue='cardProductName'
                    value={values.cardProducts}
                    onChange={handleChange}
                  />
                <InputError text={errors.cardProducts} touched={touched.cardProducts} />
              </div>
              {values.deliveryMode === "BRANCH"?
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex="3"
                    showAsterisk={cardRequestConfig["isBranchRequired"]}
                    text={t(CARD_REQUEST_KEYS.BRANCH_NAME)}
                    name='deliveryBranch'
                    mode='select'
                    list={branchList}
                    keyValue='address'
                    onChange={handleChange}
                    value={values.deliveryBranch}
                  />
                  <InputError text={errors.deliveryBranch} touched={touched.deliveryBranch} />
                </div>
                : null}
              <div className='form-group col-12'>
                <NeoInput
                  tabIndex="4"
                  showAsterisk={cardRequestConfig['isRequestTypeRequired'] ? '*' : ''}
                  text={t(CARD_REQUEST_KEYS.REQUEST_TYPE)}
                  name='requestType'
                  mode='select'
                  list={config.CARD_REQUEST_TYPES}
                  keyValue={null}
                  onChange={handleChange}
                  value={values.requestType}
                />
                <InputError text={errors.requestType} touched={touched.requestType} />
              </div>
                <div className="mt-3 form-group col-12">
                  {isSubmitting ? (
                    renderLoading()
                  ) : (
                    <NeoButton
                      tabIndex="5"
                      type="submit"
                      mode="newDesign"
                      disabled={isSubmitting}
                      text={t(BUTTON_KEYS.SUBMIT)}
                    />
                  )}
                </div>
                <div className='back-cancel-btn-container'>
                <button tabIndex={'6'} className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                onClick={() => history.goBack()}
              >
                {" "}
                {t(BUTTON_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }

  function renderConfirmation() {
    return (
      <div className="d-flex flex-column confirmation">
        <h3>{t(CARD_REQUEST_KEYS.SUBTITLE)}</h3>
        <div>
          <h6 className="label">{t(CARD_REQUEST_KEYS.ACCOUNT_NO)}</h6>
          <h6 className="value">{formValues.accountNo}</h6>
        </div>
        <div>
          <h6 className="label">{t(CARD_REQUEST_KEYS.CARD_PRODUCTS)}</h6>
          <h6 className="value">{formValues.cardProducts}</h6>
        </div>
        <div>
          <h6 className="label">{t(CARD_REQUEST_KEYS.DELIVERY_MODE)}</h6>
          <h6 className="value">{formValues.deliveryMode}</h6>
        </div>
        {formValues.deliveryMode === "BRANCH" &&
          <div>
            <h6 className="label">{t(CARD_REQUEST_KEYS.BRANCH_NAME)}</h6>
            <h6 className="value">{formValues.deliveryBranch}</h6>
          </div>
        }
        <div>
          <h6 className="label">{t(CARD_REQUEST_KEYS.REQUEST_TYPE)}</h6>
          <h6 className="value">{formValues.requestType}</h6>
        </div>

        <div>
          <TermsAndCondition module="DEBITCARD" />
        </div> 

        <div className="mt-3">
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              type="button"
              mode="newDesign"
              text={t(BUTTON_KEYS.CONFIRM)}
              onClick={() => (otpEnabled ? setStage(3) : confirmCardRequest())}
            />
          )}
        </div>
        <div className="back-cancel-style" onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </div>
    );
  }

  return (
    <LayoutWithOutAccountCard showEmptySpace={true} breadCumKey="CARD_REQUEST" keyPath="DEBIT_CARD_REQUEST">
      <div className="new-design-form-style"> {renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  );
}
